<template lang="pug">
#content
  #carousel-row.row
    swiper(ref="mySwiper",
      :options="swiperOption")
      swiper-slide.swiper-slide.optimize
        .swiper-slide-item
          .text-content 
            .big-title 账户优化-搜索推广效果提升利器
            .desc 账户问题诊断、推荐优化建议、优化效果评估，全面助力搜索推广效果提升
            a.detail-btn(
              href="/present"
              target="_blank"
            ) 查看详情
      swiper-slide.swiper-slide.searchword
        .swiper-slide-item
          .text-content
            .big-title 搜索词报告+落地页分析 助力效果评估
            .desc 新增搜索词、落地页效果数据，丰富搜索推广分析维度
            a.detail-btn(
              href="/present"
              target="_blank"
            ) 查看详情
      .swiper-pagination(slot='pagination')
    .swiper-button-prev
      .swiper-button-arrow.swiper-slick
    .swiper-button-next
      .swiper-button-arrow.swiper-slick
  .row.features
    h1.center 我们的优势
    h2.center OUR ADVANTAGES
    table.features-table
      tr
        td.cell(
          v-for="feature,index in features",
          :key="index")
          .features-item
            .features-img(:id="`features${index + 1}-img`")
            .title {{feature.title}}
            .features-detail {{feature.detail}}

  .row.experience
      h1.center 客户使用体验
      h2.center CUSTOMER EXPERIENCE
      .experience-slick
        swiper(:options='clientSwiperOption', ref='mySwiper')
          swiper-slide
            .slick-item
              .praise.disib 360分析提供的代码能帮助我们清晰的监测到不同渠道的流量情况，以及不同推广产品所带来的效果，非常直观，极大的提升了我们广告监测效率。
              .user
                img.avatar.circle.disib.fs16(src="https://p4.ssl.qhimg.com/t01f3eaa3c1376194c9.jpg")
          swiper-slide
            .slick-item
              .praise.disib 360分析提供的监测服务和访客跟踪服务帮助我们在投放广告时有效的降低了转化成本，提升了广告效果。
              .user
                img.avatar.circle.disib.fs16(src="https://p2.ssl.qhimg.com/t013f207e546b9896fd.jpg")
          swiper-slide
            .slick-item
              .praise.disib 360分析的代码帮助我们在投放广告时既实现了对访客的再营销，还实现了快速了解转化效果，是一款非常实用的工具。
              .user
                img.avatar.circle.disib.fs16(src="https://p1.ssl.qhimg.com/t0125680e52afbd0c2c.jpg")
          swiper-slide
            .slick-item
              .praise.disib 依托360分析的网站分析功能，我们能够非常清楚的区分不同关键词带来的效果如何，使得我们的账户优化能够有的放矢。
              .user
                img.avatar.circle.disib.fs16(src="https://p2.ssl.qhimg.com/t01d33da035c72beb11.jpg")
          swiper-slide
            .slick-item
              .praise.disib 在360分析的帮助下，我们能够直接看到每天产生了多少订单以及订单的来源，使得我们对于网站的交易情况尽在掌握。
              .user
                img.avatar.circle.disib.fs16(src="https://p1.ssl.qhimg.com/t01b78d90ae89fec0d3.jpg")
        .swiper-button-prev
        .swiper-button-next
  .row.partner
      h1.center 合作品牌
      h2.center COOPERATIVE BRAND
      .partner-container
        .partner-item(
          v-for="item,index in partnerSlick.length",
          :style="{backgroundImage:'url(' + partnerSlick.img + ')',backgroundPosition: '-0px -' + index*50 + 'px'}") 
        .little-person
  .ft
    site-footer
</template>

<script>
/* global _, $ */
import './css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      features: [],
      experienceSlick: [],
      partnerSlick: {},
      defaultSwiperOption: {
        autoplay: true,
        initialSlide: 0,
        direction: 'horizontal',
        autoplayDisableOnInteraction: false
      }
    }
  },
  computed: {
    swiperOption () {
      return _.extend(
        {
          autoHeight: true,
          loop: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        this.defaultSwiperOption
      )
    },
    clientSwiperOption () {
      const obj = {
        loop: true,
        loopedSlides: 5,
        initialSlide: 1,
        autoplay: true,
        watchSlidesProgress: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          progress (progress) {
            for (let i = 0; i < this.slides.length; i++) {
              const slide = this.slides.eq(i)
              const slideProgress = this.slides[i].progress
              let modify = 1

              if (Math.abs(slideProgress) > 0) {
                modify = (Math.abs(slideProgress) - 1) * 0.4 + 1
              }
              const translate = `${slideProgress * modify * 580}px`
              const scale = 1 - Math.abs(slideProgress) / 4
              const zIndex = 999 - Math.abs(Math.round(10 * slideProgress))
              slide.transform(
                `translateX(${translate}) scale(${scale})`
              )
              slide.css('zIndex', zIndex)
              slide.css('opacity', 1)
              if (Math.abs(slideProgress) > 3) {
                slide.css('opacity', 0)
              }
            }
          },
          setTransition (transition) {
            for (let i = 0; i < this.slides.length; i++) {
              const slide = this.slides.eq(i)
              slide.transition(transition)
            }
          }
        }
      }
      return obj
    },
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted () {
    $('.header').css('background-color', 'transparent')
    $(window).scroll(function (e) {
      if ($(window).scrollTop() > 100) {
        $('.header').css('background-color', '#222')
      } else {
        $('.header').css('background-color', 'transparent')
      }
    })
    $('.swiper-container').mouseover(function () {
      this.swiper.autoplay.stop()
    })
    $('.swiper-container').mouseout(function () {
      this.swiper.autoplay.start()
    })
    this.getJSONData()
  },
  methods: {
    getJSONData () {
      const PageJSON = window.$indexPageJSON
      this.features = PageJSON.features
      this.experienceSlick = PageJSON.experienceSlick
      this.partnerSlick = PageJSON.partnerSlick
    }
  }
}
</script>
<style scoped>

h2 {
  font-family: "Arial";
  font-size: 14px;
  color: rgb( 163, 177, 191 );
}
<style>



// WEBPACK FOOTER //
// index.vue?20eaab52